module.exports = __webpack_public_path__ + "static/img/open-in-browser.6b0deff6.png";